import React from 'react';
import { Screen } from '~/screens/contract-info';

export const ContractInfo: React.FC = () => <Screen />;
